<template>
  <div>
    <video ref="videoPlayer" class="video-js" :poster="poster"></video>
  </div>
</template>

<script>
import videojs from 'video.js';

export default {
  name: 'VideoJSPlayer',
  props: {
    options: {
      type: Object,
      default() {
        return {};
      },
    },
    poster: {
      type: String,
      default: null,
    },
  },
  emits: ['player-ready', 'play', 'pause', 'ended', 'timeupdate'],
  data() {
    return {
      player: null,
    };
  },
  mounted() {
    this.player = videojs(this.$refs.videoPlayer, this.options, () => {
      this.$emit('player-ready', this.player);
    });

    this.player.on('loadeddata', () => {});
    this.player.on('play', () => {
      this.$emit('play');
    });
    this.player.on('pause', () => {
      this.$emit('pause');
    });
    this.player.on('ended', () => {
      this.$emit('ended');
    });
    this.player.on('timeupdate', () => {
      const timePercentage = this.player.currentTime() / this.player.duration();
      this.$emit('timeupdate', timePercentage);
    });
  },
  onUnmounted() {
    if (this.player) {
      this.player.dispose();
    }
  },
};
</script>

<style lang="scss">
@import 'video.js/dist/video-js.css';

.video-js .vjs-tech {
  object-fit: cover;
}

.video-js .vjs-poster > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
